import { find } from './find';
import { findById } from './findById';

export const showAPI = {
  find,
  findById,
};
